import React from 'react';
import Dropzone from 'react-dropzone';
import './index.css';

const FileUpload = ({ accepted, accept, dropZoneMsg, acceptedFiles, errorMsg }) => {
  const onDrop = (acceptedFilesFromDropzone, fileRejections) => {
    acceptedFiles(acceptedFilesFromDropzone, fileRejections);
  };

  return (
    <div className="fileUploadContent">
      <div className="uploadSection">
        <Dropzone
          tabIndex="-1"
          accept={accept}
          className="hidden"
          onDrop={onDrop}
          multiple={false}
        >
          {({ getRootProps, getInputProps }) => (
            <section>
              <div {...getRootProps()}>
                <label id="dropzone-label">
                  {dropZoneMsg} <span className="requiredIndicator">*</span>
                </label>
                <input
                  {...getInputProps({
                    'aria-label': 'File Dropzone',
                    'aria-required': true,
                    'aria-describedby': 'dropzoneRequired',
                  })}
                />
                <p>or</p>
                <button aria-describedby="dropzoneButtonRequired" className="button">
                  Choose File
                </button>
                <p id="dropzoneRequired" className="visuallyHidden">
                  required
                </p>
                <p id="dropzoneButtonRequired" className="hiddenCustom">
                  required
                </p>
              </div>
            </section>
          )}
        </Dropzone>
      </div>

      <div className={accepted.length > 0 ? 'selectedFiles' : 'hiddenCustom'}>
        <div className="fileName">
          {accepted.map((file) => (
            <div key={file.size}>Selected File: {file.name}</div>
          ))}
        </div>
      </div>

      {errorMsg && (
        <div className="error fileUploadError center uploadModalSection">
          {errorMsg}
        </div>
      )}
    </div>
  );
};

export default FileUpload;
